/* global interfaceConfig */

import React from 'react';

import { isMobileBrowser } from '../../base/environment/utils';
import { translate, translateToHTML } from '../../base/i18n';
import { Icon, IconWarning } from '../../base/icons';
import { Watermarks } from '../../base/react';
import { connect } from '../../base/redux';
import { CalendarList } from '../../calendar-sync';
import { RecentList } from '../../recent-list';
import { SETTINGS_TABS, SettingsButton, openSettingsDialog } from '../../settings';

import Tabs from './Tabs';

// CUSTOM
// import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
import { AbstractWelcomePage, _mapStateToProps as _abstractMapStateToProps } from './AbstractWelcomePage';
import { getWebSocket, sendData } from '../../webjam/websocket';
import { setVideoScreenStatus, setAvatarPop, setLoginModal, showApiLoader, hideApiLoader } from '../../customise/redux/tool-webjam/actions';
import Toast from 'react-simple-toasts';
import { isNumeric } from 'jquery';
import Tutorial from '../../webjam/components/tutorial';
import Loader from 'react-loader';
import setupguide from '../../webjam/components/img/setupguide.png';
import { updateSettings } from '../../base/settings';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX_V3 } from '../../customise/constant';
import WelcomeDashboard from "../../customise/welcome-dashboard/index";
import Avatar from "../../customise/welcome-dashboard/components/Avatar";
import { decipher, dispatch, getBaseConfig, getQueryString, isIpad, isMobileBrowserC, isSocialMobileApp, SOCIAL_PATH, _ValidateIPaddress, calculateTimeDiff } from '../../customise/Utils';
import { messages } from '../../customise/welcome-dashboard/messages';
import { CURRENT_ROOM_NAME, Constant } from '../../webjam/constant';
import { DeepLinkingMobilePage } from '../../deep-linking/components';
import { Translate } from '../../webjam/language';
import { getCookie } from '../../customise/authorize/CommonFunction';
import { cloneSocket, socketEmit } from '../../../../socket';
import { getSocialToken } from '../../customise/custom/components/CommonComponents';
import { setLocalAutoConnect, setLocalBufferValue, setShowDeviceHelpingGuide } from '../../customise/redux/tool-webjam-v3/actions';
import CustomTooltip from '../../customise/custom/toolbar/CustomTooltip';
import PaymentModal from '../../customise/welcome-dashboard/components/payment';
import { getIpValidation, getMyClaimedRoomsApi, getOtherRoomsApi } from '../../customise/welcome-dashboard/Request.d';
import { setLeftMenuStatus, showPaymentDashboard } from '../../customise/welcome-dashboard/components/payment/payment-reducer/actions';
import { SaveLog } from '../../customise/Utils'
import { ct, isIframe, isValidRoomName, socialRoomsPage, webRoomNamePrefix } from '../../customise/constant-Utils';
import { LanguageSelect } from '../../customise/welcome-dashboard/components/LanguageSelect';
import { isChinaRegion } from '../../customise/custom/components/HelperComponent';
import toast from 'react-simple-toasts';
import { PushSpinner } from '../../customise/custom/components/PushSpinner';
import { OPEN_DIALOG_FROM_SOCIAL } from '../../customise/redux/tool-webjam-v3/actionType';
import { setUserSubscriptionModal } from '../../customise/redux/tool-webjam-v4/actions';
// END

/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = '^[^?&:\u0022\u0027%#]+$';

// CUSTOM
let ws, this_;
// END

/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: ''
    };

    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            // CUSTOM
            room: '',
            // END
            generateRoomnames:
                interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE,
            selectedTab: 0
        };

        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;

        this._roomInputRef = null;

        // CUSTOM
        this.submitRef = React.createRef();
        // END

        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;

        this._additionalCardRef = null;

        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById(
            'welcome-page-additional-card-template');

        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById(
            'welcome-page-additional-content-template');

        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById(
            'settings-toolbar-additional-content-template'
        );

        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef
            = this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef
            = this._setAdditionalToolbarContentRef.bind(this);
        this._onTabSelected = this._onTabSelected.bind(this);
        this._renderFooter = this._renderFooter.bind(this);
        // CUSTOM
        let socialPath = getQueryString(SOCIAL_PATH);
        if (sessionStorage.getItem("showDashboard") == "true" || socialPath == "dashboard") {
            dispatch(showPaymentDashboard(true));
            const isSideMenuOpen = (isMobileBrowserC() || isIpad()) ? false : true;
            dispatch(setLeftMenuStatus(isSideMenuOpen));
            sessionStorage.removeItem("showDashboard");
        }
        // END
    }

    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */

    // CUSTOM
    // componentDidMount() {
    async componentDidMount() {
        // END
        super.componentDidMount();

        // CUSTOM
        let socialAllowed = getBaseConfig('socialAllowed')
        if (socialAllowed) {
            const { _iAmRecorder } = this.props;
            // console.log('ghost =>', window.location.hash.indexOf("config.iAmRecorder") == -1, window.location.hash.indexOf("AUDIO_GHOST") == -1, _iAmRecorder)
            if (window.location.hash.indexOf("config.iAmRecorder") == -1 || window.location.hash.indexOf("AUDIO_GHOST") == -1 || _iAmRecorder) {
                dispatch(showApiLoader());
                let socialTokenVerified = await getSocialToken();
                await isChinaRegion();
                dispatch(hideApiLoader());
                if (!socialTokenVerified) {
                    window.parent.location.href = Constant.App.socialUrl
                }
            }
        }

        // window.history.pushState("", document.title, CURRENT_ROOM_NAME
        //     + window.location.search);

        if (CURRENT_ROOM_NAME.length > 1) {
            console.log("remove at A", CURRENT_ROOM_NAME.length)
            if (webRoomNamePrefix != CURRENT_ROOM_NAME) {
                window.history.pushState("", document.title, window.location.origin);
            }
        }

        if (CURRENT_ROOM_NAME.length < 2 && window.location.search.indexOf("auth_token") != -1) {
            console.log("remove at B")

            window.history.pushState("", document.title, window.location.origin);
        }

        if (CURRENT_ROOM_NAME.length < 2 && window.location.search.indexOf("log_token") != -1) {
            console.log("remove at C")

            let log_token = getQueryString("log_token");
            try {
                let decoded = decipher(window.location.origin)(log_token)
                if (decoded) {
                    localStorage.setItem("auth", decoded)
                    APP.store.dispatch(setLoginModal(false))
                    window.history.pushState("", document.title, window.location.origin);
                }
            } catch (e) {
                console.log("Token decode error =>", e)
            }
            console.log("remove at D")

            window.history.pushState("", document.title, window.location.origin);
        }

        if (isIframe && getBaseConfig("allowIframeOpen") == true) {
             window.parent.location.href = getBaseConfig("socialBaseUrl") + "/" + socialRoomsPage;

        }

        // REMOVE MUSIC MODE STORAGE
        localStorage.removeItem("storeDominant");
        sessionStorage.removeItem("automanagehost");
        sessionStorage.removeItem("uniqueId");

        // REMOVE MAKE HOST && MIXER POPUP FOR SAME VARIABLE: true
        localStorage.removeItem('makeHostConnect');
        localStorage.removeItem('thirdPartyMakeHostConnect');
        localStorage.removeItem('newRoomHosted');
        localStorage.removeItem('autopopup');

        // REMOVE AUTOCONNECT STORAGE VARIABLES
        localStorage.removeItem("makeHost");
        localStorage.removeItem("autoConnect");
        localStorage.removeItem("uniqueID");
        localStorage.removeItem("connectPop");
        localStorage.removeItem("windowRedirect");
        localStorage.removeItem("roomFound");
        let noChangedRoomName = getBaseConfig('noChangedRoomName')
        if (noChangedRoomName == true) {
            dispatch(setLocalAutoConnect(false));
        }

        // REMOVE PRE JOIN TIMER
        sessionStorage.removeItem("preJoinTimer");

        // REMOVE BUFERVALUE AUTOCONNECT VARIABLE
        // localStorage.removeItem("bufferValue");
        dispatch(setLocalBufferValue(false))

        // DISCONNECT SOCKET BEFORE CONNECTING NEW ONE
        if (sessionStorage.getItem("foundRoomName") && sessionStorage.getItem("foundDeviceId")) {
            var message = {
                action: {
                    ipAddress: sessionStorage.getItem("foundRoomName"),
                    uniqueID: sessionStorage.getItem("foundDeviceId"),
                },
                'content': 'server-disconnect',
                isBroadcast: true,
                sender: 'mobile',
            };

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            sendData(message);
            sessionStorage.removeItem("foundRoomName");
            sessionStorage.removeItem("foundDeviceId");
            sessionStorage.removeItem("foundProtocolId");
        }

        // Listen Socket Event Response
        this.callOnMessageEvent();
        this_ = this;
        // END

        document.body.classList.add('welcome-page');
        document.title = interfaceConfig.APP_NAME;

        if (this.state.generateRoomnames) {
            this._updateRoomname();
        }

        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef.appendChild(
                this._additionalContentTemplate.content.cloneNode(true));
        }

        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef.appendChild(
                this._additionalToolbarContentTemplate.content.cloneNode(true)
            );
        }

        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef.appendChild(
                this._additionalCardTemplate.content.cloneNode(true)
            );
        }

        // CUSTOM
        if (sessionStorage.getItem("isUserLogin_") == 'true') {
            APP.store.dispatch(setLoginModal(false))
        }

        if (localStorage.getItem("musicModeUser")) {
            this.setState({
                willStudentWait: true
            })
        }
        var __this = this;

        setTimeout(function () {
            let localMusicMode = localStorage.getItem("musicModeUser")
            console.log('localMusicMode 1 =>', localMusicMode)
            if (localMusicMode) {
                console.log('localMusicMode 2 =>', localMusicMode?.time, localMusicMode?.time + 40)
                let diff = calculateTimeDiff(localMusicMode?.time, localMusicMode?.time + 40)
                console.log('localMusicMode 3 =>', diff)
                if (diff) {
                    console.log('localMusicMode 4 =>')
                    __this.setState({
                        willStudentWait: false
                    })
                    localStorage.removeItem("musicModeUser")
                } else {
                    console.log('localMusicMode 5 =>')
                    __this.setState({
                        willStudentWait: false
                    })
                    localStorage.removeItem("musicModeUser")
                    toast(ct("rta-trmc.musicMode.musicModeNotConnected"), 10000);
                }
            }
        }, 60000)

        let getRecentRooms = localStorage.getItem("features/recent-list");
        try {
            if (getRecentRooms) {
                let allRooms = JSON.parse(getRecentRooms);
                if (allRooms.length) {
                    let lastRoom = allRooms.pop();
                    let setLastRoom = lastRoom.conference.split("/").pop();
                    if (setLastRoom.indexOf("#") != -1) {
                        setLastRoom = setLastRoom.split("#")[0];
                    }
                    // this.setState({
                    //     room: setLastRoom
                    // })
                }
            }
        } catch (e) {
            console.log("getRecentRooms error =>", e)
        }

        // MUSIC mode socket (this function is already written in layout/index.js file, but some time that is creating a problem)
        cloneSocket().on("domiantUrl_return", (data) => {
            let rName = getCookie("room");
            let rLoc = getCookie("loc");
            try {
                if (rName && rLoc) {
                    if (rLoc == data.location && rName == data.roomName) {
                        let roomUrl = data.roomLocation;
                        if (data.moderatorStatus == "enable") {
                            roomUrl += MUSIC_MODE_STRING;
                        }
                        let conferenceJoined = this.props.conferenceJoined;
                        // wait if room is not connected from main function
                        setTimeout(function () {
                            if (conferenceJoined == false) {
                                document.cookie = "room=";
                                document.cookie = "loc=";
                                sessionStorage.setItem("claimedUserD", JSON.stringify({
                                    roomLocation: data.roomLocation,
                                    time: Math.round(new Date().getTime() / 1000),
                                    // roomName: data.roomName
                                    roomName: data.roomName,
                                    tokenDecodedData: ""
                                }))
                                window.location.href = roomUrl;
                            }
                        }, 4000)
                    }
                }
            } catch (e) {
                console.log("domiantUrl_return rName && rLoc error =>", e)
            }
        })

        if (getBaseConfig("showRoomsListing")) {
            let myClaimedRoomsList = await getMyClaimedRoomsApi()
            if (myClaimedRoomsList.status == 1) {
                this.setState({
                    myClaimedRooms: myClaimedRoomsList?.data
                })
            } else {
                this.setState({
                    myClaimedRooms: ''
                })
            }

            let myOtherRoomsList = await getOtherRoomsApi()
            if (myOtherRoomsList.status == 1) {
                this.setState({
                    myOtherRooms: myOtherRoomsList?.data
                })
            } else {
                this.setState({
                    myOtherRooms: ''
                })
            }
        }
        // END
    }

    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();

        document.body.classList.remove('welcome-page');
    }

    // CUSTOM
    componentDidUpdate(prevProps) {
        const {
            isSocketConnected,
            videoScreenStatus,
            room,
            dispatch,
            isHelpModal,
            apiGetIpList,
            showDeviceHelpingGuide,
            socialSettingDialogStatus
        } = this.props;

        if (prevProps.isSocketConnected !== isSocketConnected) {
            if (isSocketConnected) {
                this.callOnMessageEvent();
            }
        }

        if (prevProps.videoScreenStatus !== videoScreenStatus) {
            if (videoScreenStatus) {
                dispatch(setVideoScreenStatus({
                    videoScreenStatus: false,
                }))
                let this_ = this;
                //sessionStorage.setItem("foundRoomName", room);
                setTimeout(function () {
                    this_._onJoin(room);
                    //this_._onJoin(room.toLowerCase());
                }, 500);
            }
        }

        // if (prevProps.apiGetIpList !== apiGetIpList) {
        //     if (apiGetIpList) {
        //         //const { room } = this.state;
        //         const room = this.state.room.toLowerCase().trim();
        //         let ipArr = apiGetIpList.data;

        //         if (ipArr.includes(room)) {
        //             //if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
        //                 this._onJoin();
        //             //}
        //         } else {
        //             setTimeout(function () {
        //                 Toast(messages.enterDiffIpAddress, Constant.App.ToastTime.LongCloseTime);
        //             }, 100)
        //         }
        //     }
        // }

        if (prevProps.showDeviceHelpingGuide != showDeviceHelpingGuide && showDeviceHelpingGuide == true) {
            if (showDeviceHelpingGuide == true) {
                this.startTutorial();
            }
        }
    }

    callOnMessageEvent() {
        // To CLEAR LOCAL STORAGE ON CLICK OF CALL BUTTON AT WELCOME
        // localStorage.clear();
        ws = getWebSocket();
    }

    socialWebLink(e) {
        if (window.confirm(ct("Translate.confirmMessages.socialRedirect"))) {
            window.parent.location.href = Constant.App.socialUrl
        }
    }

    setRoomName(item) {
        dispatch(showApiLoader({
            loaderAdditionalDetail: "Loading",
        }));
        this.setState({
            room: item
        })
        let _this = this;
        setTimeout(function () {
            _this.submitRef.current.click()
        }, 2000)
        setTimeout(function () {
            dispatch(hideApiLoader());
        }, 10000)
    }
    // END

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        // CUSTOM
        // const { _moderatedRoomServiceUrl, t } = this.props;
        const { _moderatedRoomServiceUrl, t, dashboardLogin, isShowPaymentDashboard, userLoginData, loadingShow } = this.props;
        // END
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } = interfaceConfig;
        const showAdditionalCard = this._shouldShowAdditionalCard();
        const showAdditionalContent = this._shouldShowAdditionalContent();
        const showAdditionalToolbarContent = this._shouldShowAdditionalToolbarContent();
        const contentClassName = showAdditionalContent ? 'with-content' : 'without-content';

        // CUSTOM
        // const footerClassName = DISPLAY_WELCOME_FOOTER ? 'with-footer' : 'without-footer';
        const footerClassName = 'with-footer';
        const files = this.state.files;
        const { willStudentWait, myClaimedRooms, myOtherRooms } = this.state;
        const welcomeLogo = getBaseConfig("welcomeLogo");
        let enterRoomName;
        let socialLinkImage = getBaseConfig("socialWebLogoWhite");
        const roomnameAccLabel = 'welcomepage.accessibilityLabel.roomname';


        if ((isIpad() || isMobileBrowserC()) && getBaseConfig("deeplinking") == true) { // mobile
            return <DeepLinkingMobilePage />
        } else {
            if (this.state.room) {
                enterRoomName = this.state.room;
                enterRoomName = enterRoomName.split('?socialAuth=');
                enterRoomName = enterRoomName[0];
            }

            if (isShowPaymentDashboard) {
                return <div
                    className={`welcome dashboard-wrapper ${contentClassName} ${footerClassName} welcome-gray-bg`}
                    id='welcome_page'><PaymentModal /></div>
            }

            return (
                <>
                    <div className="main login">
                        {loadingShow && (
                            <>
                                {getBaseConfig("showPushSpinnerLoader") ?
                                    <div className="loader-text-container R">
                                        <div className='loader-wrapper'>
                                            <PushSpinner
                                                size={30}
                                                color="white"
                                                loading={true}
                                                className={"loader-text-main"}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <Loader
                                        loaded={false}
                                        options={{ color: "white" }}
                                    ></Loader>
                                }
                            </>
                        )}
                    </div>
                    <div
                        className={`welcome dashboard-wrapper ${contentClassName} ${footerClassName} ${!isShowPaymentDashboard ? "welcome-dashboard" : ""}`}
                        id='welcome_page'>

                        {/* {getBaseConfig("socialAllowed") && (!userLoginData?.user?.is_app || !isSocialMobileApp()) &&
                    <Tooltip
                        title="Click here to continue to the RealTime Audio Social Network"
                        placement="right"
                        arrow
                        id="social-web-link-tooltip-main"
                    >
                        <div className='social-web-link-container-main'>
                            <img src={socialLinkImage} className='social-web-link-logo-main' onClick={(e) => this.socialWebLink(e)} />
                        </div>
                    </Tooltip>
                } */}

                        {willStudentWait &&
                            <div className={"musicModeWaiting"}>
                                <div style={{ height: "60%" }}>
                                    {getBaseConfig("showPushSpinnerLoader") ?
                                        <div className="loader-text-container">
                                            <div className='loader-wrapper'>
                                                <PushSpinner
                                                    size={30}
                                                    color="white"
                                                    loading={true}
                                                    className={"loader-text-main"}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <Loader
                                            loaded={false}
                                            options={{ color: "white" }}
                                        ></Loader>
                                    }
                                </div>
                                <div style={{ height: "40%", color: "#fff" }} className="text-center font18 music-mode-message">
                                    {getBaseConfig("willAuthorize") == true ? ct("messages.studentWaitingMusicModeMessage", "messages") : ct("Translate.musicModeWaiting")}
                                </div>
                            </div>
                        }
                        {(!getBaseConfig("willAuthorize") && !getBaseConfig("socialAllowed")) && <WelcomeDashboard />}
                        {(getBaseConfig("willAuthorize") || !dashboardLogin || getBaseConfig("socialAllowed")) &&
                            <div>
                                <div className='header' >
                                    {this.state.showHelpModal && <Tutorial onClose={this._closeHelpModal} />}
                                    {!getBaseConfig("showMenuList") && getBaseConfig("showHomePageHomeIcon") == false ?
                                        <div className="welcome-page-setting-container d-block d-flex justify-content-between">
                                            <div className='welcome-page-settings ques'>
                                                <div id='toolbox-icon' className="toolbox-button" onClick={() => {
                                                    this.startTutorial();
                                                    dispatch(setAvatarPop(false));
                                                }}>
                                                    <CustomTooltip
                                                        content={t("rta-trmc.avatar.troubleShotV2")}
                                                        position={"bottom"}>
                                                        <div className="toolbox-icon">
                                                            <img height="38px" width="38px" src={setupguide} />
                                                        </div>
                                                    </CustomTooltip>
                                                </div>
                                            </div>
                                            <div id='settings-icon' className='welcome-page-settings' onClick={() => dispatch(setAvatarPop(false))}>
                                                <SettingsButton
                                                    tooltipPosition="bottom"
                                                    defaultTab={SETTINGS_TABS.CALENDAR} />
                                                {showAdditionalToolbarContent
                                                    ? <div
                                                        className='settings-toolbar-content'
                                                        ref={this._setAdditionalToolbarContentRef} />
                                                    : null
                                                }
                                            </div>
                                            <div className='welcome-page-settings'>
                                                <LanguageSelect />
                                            </div>
                                            <div className="welcome-page-settings">
                                                {!getBaseConfig("willAuthorize") &&
                                                    <>
                                                        {getBaseConfig("guestUser") ?
                                                            <Avatar />
                                                            :
                                                            <CustomTooltip content={t("rta-trmc.avatar.dashboard")}
                                                                position={"bottom"}><Avatar /></CustomTooltip>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="welcome-page-setting-container d-block d-flex justify-content-between avatar-wrapper">
                                            <div className='welcome-page-settings'>
                                                <LanguageSelect />
                                            </div>
                                            <div className="welcome-page-settings">
                                                {!getBaseConfig("willAuthorize") &&
                                                    <Avatar />
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div className='header-image' >
                                        <div className="header-image-container">
                                            <img src={welcomeLogo} />
                                        </div>
                                        {getBaseConfig("welcomeTitle") == true &&
                                            <div className="header-image-title">
                                                <span className="header-text-subtitle">{t("rta-trmc.welcome.hello")}</span>
                                            </div>
                                        }
                                    </div>
                                    {getBaseConfig("roomEnter") == true &&
                                        <div id='enter_room' data-value={enterRoomName}>
                                            <div className='enter-room-input-container'>
                                                <form onSubmit={this._onFormSubmit}>
                                                    {myClaimedRooms?.length > 0 || myOtherRooms?.length > 0 ?
                                                        <div className='room-name-entry'>
                                                            {myClaimedRooms?.length > 0 &&
                                                                <div className='my-rooms'>
                                                                    <label id='my-rooms-label' className='my-rooms-label'><u>{t("rta-trmc.welcome.myRoom")}</u></label>
                                                                    <div className='my-rooms-listing'>
                                                                        {myClaimedRooms?.length > 0 && myClaimedRooms.map((item, index) => {
                                                                            return <li
                                                                                key={index}
                                                                                id={`my-rooms-${index}`}
                                                                                className='my-rooms-list'
                                                                                onClick={(e) => this.setRoomName(item.groupName)}
                                                                            >
                                                                                {item.groupName}
                                                                            </li>
                                                                        })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }

                                                            {myOtherRooms?.length > 0 &&
                                                                <div className='other-rooms'>
                                                                    <label id='other-rooms-label' className='other-rooms-label'><u>{t("rta-trmc.welcome.otherRoom")}</u></label>
                                                                    <div className='other-rooms-listing'>
                                                                        {myOtherRooms?.length > 0 && myOtherRooms.map((item, index) => {
                                                                            return <li
                                                                                id={`other-rooms-${index}`}
                                                                                key={index}
                                                                                className='other-rooms-list'
                                                                                onClick={(e) => this.setRoomName(item.groupName)}
                                                                            >
                                                                                {item.groupName}
                                                                            </li>
                                                                        })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }

                                                            <div className='manual-room-name'>
                                                                <input
                                                                    aria-disabled='false'
                                                                    aria-label='Meeting name input'
                                                                    autoFocus={true}
                                                                    className='enter-room-input'
                                                                    id='enter_room_field room_name'
                                                                    onChange={this._onRoomChange}
                                                                    pattern={ROOM_NAME_VALIDATE_PATTERN_STR}
                                                                    placeholder={t(roomnameAccLabel)}
                                                                    ref={this._setRoomInputRef}
                                                                    title={t('welcomepage.roomNameAllowedChars')}
                                                                    type='text'
                                                                    maxLength='25'
                                                                    value={enterRoomName} />
                                                                <button
                                                                    aria-disabled='false'
                                                                    aria-label='Start meeting'
                                                                    className='welcome-page-button'
                                                                    id='enter_room_button'
                                                                    onClick={this._onFormSubmit}
                                                                    tabIndex='0'
                                                                    ref={this.submitRef}
                                                                    type='button'>
                                                                    {/* CUSTOM */}
                                                                    {/* text changed in main.json */}
                                                                    {t('welcomepage.startMeeting')}
                                                                    {/* END */}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className='manual-room-name'>
                                                            <input
                                                                aria-disabled='false'
                                                                aria-label='Meeting name input'
                                                                autoFocus={true}
                                                                className='enter-room-input'
                                                                id='enter_room_field room_name'
                                                                onChange={this._onRoomChange}
                                                                pattern={ROOM_NAME_VALIDATE_PATTERN_STR}
                                                                placeholder={t(roomnameAccLabel)}
                                                                ref={this._setRoomInputRef}
                                                                title={t('welcomepage.roomNameAllowedChars')}
                                                                type='text'
                                                                maxLength='20'
                                                                value={enterRoomName} />
                                                            <button
                                                                aria-disabled='false'
                                                                aria-label='Start meeting'
                                                                className='welcome-page-button'
                                                                id='enter_room_button'
                                                                onClick={this._onFormSubmit}
                                                                tabIndex='0'
                                                                ref={this.submitRef}
                                                                type='button'>
                                                                {/* CUSTOM */}
                                                                {/* text changed in main.json */}
                                                                {t('welcomepage.startMeeting')}
                                                                {/* END */}
                                                            </button>
                                                      
                                                        </div>
                                                    }
                                                </form>
                                            </div>
                                            {/* <button onClick={() => {
                                                            dispatch(setUserSubscriptionModal(true))
                                                        }}>Click</button> */}
                                        </div>
                                    }

                                    {_moderatedRoomServiceUrl && (
                                        <div id='moderated-meetings'>
                                            <p>
                                                {
                                                    translateToHTML(
                                                        t, 'welcomepage.moderatedMessage', { url: _moderatedRoomServiceUrl })
                                                }
                                            </p>
                                        </div>)}
                                </div>

                                <div className='welcome-cards-container'>
                                    {getBaseConfig("siteTitle") && <div className="site-title-cust">{getBaseConfig("siteTitle")}</div>}
                                    <div className='welcome-card-row'>
                                        <div className='welcome-tabs welcome-card welcome-card--blue'>
                                            {this.props._isCalendarIntegrationType ?
                                                this._renderTabs()
                                                : null}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </>
            );
            // END
        }
    }

    // CUSTOM
    startTutorial = () => {
        localStorage.setItem('ifFirstVisit', true);
        // this.setState({ position: 0 });
        this.setState({
            position: 0,
            introButton: false,
            showHelpModal: true,
        });
    }

    _closeHelpModal = () => {
        dispatch(setShowDeviceHelpingGuide(false))
        this.setState({
            showHelpModal: false,
            position: 0,
            introButton: false,
        });
    }

    // VALIDATE IP ADDRESS BEFORE CALL
    _ValidateIPaddress(ipaddress) {
        if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
            return (true)
        } else {
            return (false)
        }
    }
    // END

    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (
            <div className='insecure-room-name-warning'>
                <Icon src={IconWarning} />
                <span>
                    {this.props.t('security.insecureRoomNameWarning')}
                </span>
            </div>
        );
    }

    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    // CUSTOM
    // _onFormSubmit(event) {
    async _onFormSubmit(event) {
        // END
        event.preventDefault();

        // CUSTOM
        // if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
        //     this._onJoin();
        // }
        const { dispatch } = this.props;
        dispatch(updateSettings({
            userSelectedSkipPrejoin: false,
        }));

        let value = this.state.room.toLowerCase().replace(/\s/g, '').trim();
        // social url change code
        let socialAllowed = getBaseConfig("socialAllowed");
        let socialReferrerUrl = getBaseConfig('socialReferrerUrl')
        if (socialAllowed == true && value.length > 1 && !isNumeric(value)) {
            let rep = 0;
            let willStop = isValidRoomName(value);
            if (willStop) {
                return false;
            }

            if (_ValidateIPaddress(value)) {
                if (value.includes(":")) {
                    value = value.replace(":", "_")
                }
                let isValid = await getIpValidation(value);
                if (isValid.status == 2 && rep == 0) {
                    rep++;
                    let newRoomName = isValid.response.data.newRoomName
                    if (newRoomName.includes(":")) {
                        newRoomName = newRoomName.replace(":", "_")
                    }
                    console.log("ip 0 =>", CURRENT_ROOM_NAME, newRoomName)
                    if (CURRENT_ROOM_NAME != newRoomName) {
                        if (isSocialMobileApp()) {
                            window.parent.location.href = getBaseConfig("appReferrerUrl") + "/" + newRoomName;
                        } else {
                            window.parent.location.href = socialReferrerUrl + '/' + newRoomName;
                        }
                    }
                }
            } else {
                window.parent.location.href = socialReferrerUrl + '/' + value;
            }
        }

        if ((value.includes('.')) && !value.includes('.melomax.cloud')) {
            if (_ValidateIPaddress(value) && value != "1.1.1.1") {
                // dispatch(getipListFromApi());
                // JOIN ROOM WITHOUT FINDING IN LIST
                this._onJoin();
            } else {
                //setTimeout(function () {
                Toast(ct("messages.invalidIp", "messages"), Constant.App.ToastTime.LongCloseTime);
                return (false);
                //}, 100)
            }
        } else if (value.includes('.melomax.cloud')) {
            (async () => {
                var response = await fetch('https://dns.google/resolve?name=' + value);
                var json = await response.json();
                if (json && json.Answer) {
                    value = json.Answer[0].data;
                    if (_ValidateIPaddress(value) && value != "1.1.1.1") {
                        // dispatch(getipListFromApi());
                        // JOIN ROOM WITHOUT FINDING IN LIST
                        this._onJoin();
                    } else {
                        //setTimeout(function () {
                        Toast(ct("messages.invalidIp", "messages"), Constant.App.ToastTime.LongCloseTime);
                        return (false);
                        //}, 100)
                    }
                }
            })();
        } else if (isNumeric(value)) {
            Toast(ct("messages.invalidNumericRoom", "messages"), Constant.App.ToastTime.LongCloseTime);
            return (false);
        } else if (value.length > 25) {
            Toast(ct("messages.invalidRoomLength", "messages"), Constant.App.ToastTime.LongCloseTime);
            return (false);
        } else if (value.length < 1) {
            Toast(ct("messages.roomnameRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return (false);
        } else if (value.length < 3) {
            Toast(ct("messages.inviteNameLength", "messages"), Constant.App.ToastTime.LongCloseTime);
            return (false);
        } else {
            // SET ROOM NAME IN STORAGE
            sessionStorage.setItem("foundRoomName", value);
            this._onJoin();
        }
        // END
    }

    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    _onRoomChange(event) {
        // CUSTOM
        // UPDATE ROOMNAME TO LOWERCASE
        // super._onRoomChange(event.target.value);
        let value = event.target.value.toLowerCase().replaceAll(/\s/g, '').trim();
        super._onRoomChange(value);
        // END
    }

    /**
     * Callback invoked when the desired tab to display should be changed.
     *
     * @param {number} tabIndex - The index of the tab within the array of
     * displayed tabs.
     * @private
     * @returns {void}
     */
    _onTabSelected(tabIndex) {
        this.setState({ selectedTab: tabIndex });
    }

    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    _renderFooter() {
        const {
            t,
            _deeplinkingCfg: {
                ios = {},
                android = {}
            }
        } = this.props;

        const { downloadLink: iosDownloadLink } = ios;

        const { fDroidUrl, downloadLink: androidDownloadLink } = android;

        return (<footer className='welcome-footer'>
            <div className='welcome-footer-centered'>
                <div className='welcome-footer-padded'>
                    <div className='welcome-footer-row-block welcome-footer--row-1'>
                        <div className='welcome-footer-row-1-text'>{t('welcomepage.jitsiOnMobile')}</div>
                        <a
                            className='welcome-badge'
                            href={iosDownloadLink}>
                            <img
                                alt={t('welcomepage.mobileDownLoadLinkIos')}
                                src='./images/app-store-badge.png' />
                        </a>
                        <a
                            className='welcome-badge'
                            href={androidDownloadLink}>
                            <img
                                alt={t('welcomepage.mobileDownLoadLinkAndroid')}
                                src='./images/google-play-badge.png' />
                        </a>
                        <a
                            className='welcome-badge'
                            href={fDroidUrl}>
                            <img
                                alt={t('welcomepage.mobileDownLoadLinkFDroid')}
                                src='./images/f-droid-badge.png' />
                        </a>
                    </div>
                </div>
            </div>
        </footer>);
    }

    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }

        const { _calendarEnabled, _recentListEnabled, t } = this.props;

        const tabs = [];

        if (_calendarEnabled) {
            tabs.push({
                label: t('welcomepage.upcomingMeetings'),
                content: <CalendarList />
            });
        }

        if (_recentListEnabled) {
            tabs.push({
                label: t('welcomepage.recentMeetings'),
                content: <RecentList />
            });
        }

        if (tabs.length === 0) {
            return null;
        }

        return (
            <Tabs
                onSelect={this._onTabSelected}
                selected={this.state.selectedTab}
                tabs={tabs} />);
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }

    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }

    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD
            && this._additionalCardTemplate
            && this._additionalCardTemplate.content
            && this._additionalCardTemplate.innerHTML.trim();
    }

    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT
            && this._additionalContentTemplate
            && this._additionalContentTemplate.content
            && this._additionalContentTemplate.innerHTML.trim();
    }

    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT
            && this._additionalToolbarContentTemplate
            && this._additionalToolbarContentTemplate.content
            && this._additionalToolbarContentTemplate.innerHTML.trim();
    }
}

// CUSTOM
function _mapStateToProps(state) {
    const calendarState = state['features/calendar-sync'] || {};

    return {
        ..._abstractMapStateToProps(state),
        _isCalendarIntegrationType: calendarState.integrationType,
        isConnected: state[FEATURE_CUSTOM_REDUX].isConnected,
        isInternetConnected: state[FEATURE_CUSTOM_REDUX].isInternetConnected,
        isSocketConnected: state[FEATURE_CUSTOM_REDUX].isSocketConnected,
        uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
        room: state[FEATURE_CUSTOM_REDUX].room,
        connected: state[FEATURE_CUSTOM_REDUX].connected,
        joinRoomModalStatus: state[FEATURE_CUSTOM_REDUX].joinRoomModalStatus,
        videoScreenStatus: state[FEATURE_CUSTOM_REDUX].videoScreenStatus,
        protocolId: state[FEATURE_CUSTOM_REDUX].protocolId,
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        isHelpModal: state[FEATURE_CUSTOM_REDUX].isHelpModal,
        showModalError: state[FEATURE_CUSTOM_REDUX].showModalError,
        errorMessage: state[FEATURE_CUSTOM_REDUX].errorMessage,
        deviceList: state[FEATURE_CUSTOM_REDUX].deviceList,
        apiGetIpList: state[FEATURE_CUSTOM_REDUX].apiGetIpList,
        dashboardLogin: state[FEATURE_CUSTOM_REDUX].dashboardLogin,
        _iAmRecorder: state['features/base/config'].iAmRecorder,
        isShowPaymentDashboard: state[FEATURE_CUSTOM_PAYMENT].isShowPaymentDashboard,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        showLoading: state[FEATURE_CUSTOM_REDUX].showLoader,
        showDeviceHelpingGuide: state[FEATURE_CUSTOM_REDUX_V3].showDeviceHelpingGuide,
        loadingShow: state[FEATURE_CUSTOM_REDUX].showLoader
    };
}
// END

export default translate(connect(_mapStateToProps)(WelcomePage));
